import { UPLOAD_URL } from '@/constant/vite_env';
import { dataInfoOptions } from '@/mobile/monthly/completion_resource/info_task/cpns/config';
import { alovaInstance } from '@/utils/alova';
import { isPC } from '@/utils/tools';
interface PageParams {
    size?: number;
    current?: number;
    [attr: string]: any;
}

// 移动端登录 api
export const mobileLoginApi = (data: Record<string, any>) => {
    const loginInstance = alovaInstance.Post<Record<string, any>>('/pfuser/m/oauth/login', data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            // 区分不同端，解决PC移动同时登录问题
            Authorization: isPC() ? 'Basic cGN3eG1wOnBjd3htcA==' : 'Basic bW9iaWxlOm1vYmlsZQ=='
        }
    });
    loginInstance.meta = {
        noToken: true
    };
    return loginInstance;
};

// 第三方登录 api
export const thirdPartyLoginPostApi = <T = any>(data: Record<string, any>) => {
    const hirdPartyLoginInstance = alovaInstance.Post<T>('/pfuser/social-oauth/login', data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: 'Basic cXl3eDpxeXd4'
        }
    });
    hirdPartyLoginInstance.meta = {
        noToken: true
    };
    return hirdPartyLoginInstance;
};

// 用户信息 api
export const userInfoGetApi = alovaInstance.Get<Record<string, any>>('/admin/m/user/info', {
    params: { scopeCode: 'mobile' },
    transformData(rawData) {
        return {
            data: rawData
        };
    }
});

// 分页选择用户 api
export const userSelectGetApi = (data: Record<string, any>) => {
    return alovaInstance.Post<Record<string, any>>('/admin/m/user/page-select', data);
};

// 获取租户列表 api
export const tanantListGetApi = (scopeCode: string) =>
    alovaInstance.Get<Record<string, any>>('/admin/account-grant-auth/v3/grant/toggle-tenant', {
        params: { scopeCode }
    });

// 获取租户列表 api
export const tanantListV4GetApi = (data: Record<string, any>) =>
    alovaInstance.Post<Record<string, any>>('/admin/m/busi-app/tenant-list', data);

// 获取租户Token api
export const tenantTokenPostApi = (userId: string) =>
    alovaInstance.Post<Record<string, any>>(`/auth/account-grant/switch-user-v2/${userId}`);

// 获取租户Token api
export const tenantTokenV2PostApi = (data: Record<string, any>) =>
    alovaInstance.Post<Record<string, any>>(`/admin/m/busi-app/token-exchange`, data);

// 获取七牛云token
export const qiniuTokenGetApi = () => {
    return alovaInstance.Get('/admin/api/qiniu/token');
};

// 个人中心获取七牛云token
export const personalQiniuTokenGetApi = <T = any>() => {
    return alovaInstance.Get<T>('/pfuser/third-part-token/qiniu');
};

// 七牛云文件上传 api
interface QiniuUploadDataType {
    hash: string;
    key: string;
}

export const qiniuUploadFileApi = (data: any) => {
    return alovaInstance.Post<QiniuUploadDataType>(UPLOAD_URL, data, {
        requestType: 'upload',
        fileType: 'image'
    });
};

// 获取短信验证码（登录/注册） api
export const smsLoginPostApi = <T = any>(data: Record<string, any>) => {
    const smsLogininInstance = alovaInstance.Post<T>('/pfuser/pf-user/send-sms', data);
    smsLogininInstance.meta = {
        noToken: true
    };
    return smsLogininInstance;
};

// 获取短信验证码（更改手机号/修改密码） api
export const smsPostApi = <T = any>(data: Record<string, any>) =>
    alovaInstance.Post<T>('/admin/mis-pfu/inner-send-sms', data);

// 手机号绑定 api
export const phoneBindPostApi = <T = any>(data: Record<string, any>) => {
    const phoneBindInstance = alovaInstance.Post<T>('/pfuser/pf-user/phone-bind', data, {
        headers: {
            Authorization: 'Basic bW9iaWxlOm1vYmlsZQ=='
        }
    });
    phoneBindInstance.meta = {
        noToken: true
    };
    return phoneBindInstance;
};

// 流程信息 api
export const flowableTaskGet = (id: string) => {
    return alovaInstance.Get<any>(`/flow/flowable-task/comments/process/${id}`);
};

// 流程信息的催办
export const taskUrgePost = (data: Record<string, any>) => alovaInstance.Post('/flow/task-urge/start', data);

// 审批详情
export const processInfoGet = (id: string) => {
    return alovaInstance.Post(`/flow/m/process-approval/process-info/${id}`, {
        transformData: (res: any) => res.comments || []
    });
};

// 项目相关金额 api
export const projectNumGetApi = (projectId: string) => {
    return alovaInstance.Get(`/fnc/fin-subject-item/obtain-project-related-amount/${projectId}`);
};

// 项目相关(合同) api
export const projectContractGetApi = (projectId: string) => {
    return alovaInstance.Get(`/pm/receipt/contract-info/info-by-project/${projectId}`);
};

// 项目应扣款项的表格数据 api
export const deductedTablePostApi = <T = any>(data: Record<string, any> = {}) => {
    return alovaInstance.Post<T>('/pm/project-deduction-detail/page', data);
};

// 项目暂扣台账表格数据 api
export const retainageTablePostApi = (data: Record<string, any> = {}) => {
    return alovaInstance.Post('/pm/short-deduction/page', data);
};

// 公司银行账号分页 api
export const comBankInfoPostApi = (data: Record<string, any> = {}) => {
    return alovaInstance.Post('/pm/project-bank-card-related/mobile/page', data);
};

// 项目选择银行卡分页 api
export const ProjBankInfoPostApi = (data: Record<string, any> = {}) => {
    return alovaInstance.Post('/pm/project-bank-card-related/choose/bank-card', data);
};

// 银行账号信息分页 api
export const bankInfoGetApi = (data: PageParams = {}) => {
    return alovaInstance.Post('/universal/bank-account/page', data);
};

// 集团银行账号信息分页 api
export const groupBankInfoGetApi = (data: Record<string, any> = {}) => {
    return alovaInstance.Post('/universal/bank-card/data-page', data);
};

// 公司代管、项目自管银行账号分页 api
export const comBankInfoGetApi = <T = any>(data: Record<string, any> = {}) => {
    return alovaInstance.Post('/pm/project-bank-card-related/page', data);
};

// 统计图表 api
export const sumEchartGetApi = <T = Record<string, any>>(id: string) => {
    return alovaInstance.Get<T>(`/pm/project/lessor/summary/stat/${id}`);
};

// 字典下拉选择数据 api
export const dictSelectGetApi = <T = any>(dictName: string) => {
    return alovaInstance.Get<T>(`/admin/dict/type/${dictName}`);
};

// 提示语下拉选择数据 api
export const promptConfigGetApi = <T = any>(params: any = {}) => {
    return alovaInstance.Get<T>('/universal/prompt-config/select/data', { params: { size: 60, ...params } });
};

// 集团公司的下拉选择 api
export const subjectSelGetApi = <T = any>(params: any = {}) => {
    return alovaInstance.Get<T>('/universal/company/select-group', { params: { size: 60, ...params } });
};

// 附加税的字段列表 api
export const taxFieldGetApi = <T = any>() => {
    return alovaInstance.Get<T>('/pm/surtax-type/sel-surtax-type');
};

// 工资发放台账-汇总统计 api
export const deductibleFundGetApi = (projectId: string) => {
    return alovaInstance.Get('/fnc/fin-subject-item/select/deductible-fund', { params: { projectId } });
};

// 报表配置下拉选择 api
export const reportSelectGetApi = <T = Record<string, any>>() => {
    return alovaInstance.Get<T>('/fnc/report-configuration/select-data');
};

// 明细模式 api
export const detailPagePostApi = <T = any>(data: Record<string, any>) => {
    return alovaInstance.Post<T>('/fnc/fin-subject-item/fund-summary-item/page', data);
};

// 最近进入项目 api
export const lastProjectGetApi = <T = Record<string, any>>(data: Record<string, any>) => {
    return alovaInstance.Post<T>('/pm/m/project-info/recently-page', data);
};

// 我的关注 api
export const myAttentionGetApi = <T = Record<string, any>>(data: Record<string, any>) => {
    return alovaInstance.Post<T>('/pm/m/project-info/collect-page', data);
};

// 项目阶段数据 api
export const projectStepsGetApi = <T = Record<string, any>>() => {
    return alovaInstance.Get<T>('/pm/project-stage/get-all-data');
};

// 项目关注 api
export const attentionPostApi = <T = Record<string, any>>(data: Record<string, any>) => {
    return alovaInstance.Post<T>('/pm/project-collect/save', data);
};

// 项目取消关注 api
export const attentionDelApi = <T = Record<string, any>>(projectId: string) => {
    return alovaInstance.Delete<T>(`/pm/project-collect/del/${projectId}`);
};
export const projectPagePostApi = <T = any>(data: Record<any, any> = {}) => {
    return alovaInstance.Post('/pm/m/project-info/data-page', data);
};
// 选择我的项目的表格数据 api
export const myProjectGetApi = <T = any>(data: Record<any, any> = {}) => {
    return alovaInstance.Post('/pm/project-info/my-page', data);
};

// 项目台账信息详情 api
export const projectInfoGetApi = <T = any>(projectId: string) => {
    return alovaInstance.Get<T>('/pm/project-info/info', { params: { projectId } });
};

// 菜单列表 api
export const menusGetApi = <T = Record<string, any>[]>(scopeCode: string) => {
    return alovaInstance.Get<T>('/admin/menu/tree', { params: { scopeCode } });
};

// 集团公司的下拉选择 api
export const subjectGroupSelGetApi = <T = any>(params: any = {}) => {
    return alovaInstance.Get<T>('/universal/group-subject/select-data', { params: { size: 60, ...params } });
};

// 所属投标的下拉选择 api
export const bidSelGetApi = <T = any>(projectName = '') => {
    return alovaInstance.Get<T>('/bid/bid-info/select', { params: { projectName, size: 60 } });
};

/**
 * 项目名称搜索请求数据 api
 * @param {string} name 搜索的文本
 * @param {string} partyAB 是否需要甲乙方信息, 值为 1 表示需要
 * @param {string} size 返回的数据记录数
 * @returns {ApiAwaitReturn}
 */
export const proSelectGetApi = <T = any>(name = '', partyAB = '', size = 60, deptId = '') => {
    return alovaInstance.Get<T>('/pm/project-info/select/data', { params: { name, partyAB, size, deptId } });
};

// 获取流程定义 ID 的 api
export const processIdGetApi = <T = any>(code: string) => {
    return alovaInstance.Get<T>(`/flow/flowable-process-def/code/${code}`);
};

// 根据当前项目id返回是否进入尾款范围 api
export const projectArrearsMarginGetApi = <T = any>(projectId: string) => {
    return alovaInstance.Get<T>(`/pm/margin-ratio-config/project-arrears-margin/${projectId}`);
};

// 我的关注 api
export const collectTaxSituationPageGetApi = <T = Record<string, any>>(data: Record<string, any>) => {
    return alovaInstance.Post<T>('/pm/m/project-info/collect-tax-situation-page', data);
};

// 工作台-项目阶段与施工情况总览 api
export const constructionSituationGetApi = <T = any>() => {
    return alovaInstance.Get<T>('/pm/project-info/stage-construction-situation');
};

// 资金使用 api
export const workbenchFundStatGetApi = <T = any>(yearSearch: number) => {
    return alovaInstance.Get<T>('/pm/receipt-invoice/workbench-fund-stat', { params: { yearSearch } });
};
// 保存更新用户电子签名信息 api
export const signatureSavePostApi = <T = any>(data: Record<any, any> = {}) => {
    return alovaInstance.Post('/admin/mis-pfu/e-signature-save', data);
};

// 用户电子签名信息 api
export const signatureInfoGetApi = <T = any>() => {
    return alovaInstance.Get<T>(`/admin/mis-pfu/e-signature-info`);
};

// 保存更新用户电子签名信息 api
export const signaturePerSavePostApi = <T = Record<string, any>>(data: Record<string, any>) => {
    return alovaInstance.Post<T>('/pfuser/pfu-e-signature/save', data);
};

// 查询人员名单配置 api
export const wageRosterGetApi = <T = any>() => {
    return alovaInstance.Get<T>('/pm/wage-roster/select/data');
};

// 查询全部开票配置数据
export const invoiceCollectionConfigApi = <T = any>() => {
    return alovaInstance.Get<T>('/fnc/invoice-collection-config/select-all');
};

// 表格数据 api
export const finSubjectItemtablePostApi = <T = any>(data: Record<string, any> = {}) => {
    return alovaInstance.Post<T>('/fnc/fin-subject-item/proj-inv-paym-det/page', data);
};

// 汇总 api
export const rollupInfoGetApi = <T = Record<string, any>>(projectId: string) => {
    return alovaInstance.Get<T>('/fnc/fin-subject-item/proj-inv-paym-det/rollup', { params: { projectId } });
};

// 统计 api
export const statsPostApi = <T = any>(data: Record<string, any> = {}) => {
    return alovaInstance.Post<T>('/fnc/fin-subject-item/proj-inv-paym-det/stats', data);
};

// 添加水印 api
export const addWatermarkGetApi = <T = any>(url: string) => {
    return alovaInstance.Get<T>('/universal/resource-file/add-watermark', { params: { url }, requestType: 'download' });
};
// 发票税率请求数据 api
export const taxSelectGetApi = <T = any>() => {
    return alovaInstance.Get<T>('/pm/invoice-tax-rate/select-list');
};

// 项目合同价款汇总 api
export const projectContractPriceGetApi = <T = any>(projectId: string) => {
    return alovaInstance.Get<T>(`/pm/m/project-info/contract-price/${projectId}`);
};

// 业务端用户应用列表 api
export const adminUserAppsGetApi = () => {
    return alovaInstance.Get<Record<string, any>>('/admin/user-authority/user-apps');
};

// 项目收支统计 api
export const incomeExpenseTotalGetApi = <T = Record<string, any>>(projectId: string) => {
    return alovaInstance.Get<T>('/fnc/fin-subject-item/fund/income-expense-total', { params: { projectId } });
};

// 项目收支统计 api
export const incomeExpenseTotalCompareGetApi = <T = Record<string, any>>(projectId: string) => {
    return alovaInstance.Get<T>(`/fnc/fin-subject-item/project-income-expense-statistics/${projectId}`);
};

// 业务主体的下拉选择 api
export const comSelectGetApi = <T = Record<string, any>[]>(params?: Record<string, any>) => {
    return alovaInstance.Get<T>('/universal/company/select', { params: { size: 60, ...params } });
};

// 收款合同类型树形数据 api
export const receiptSelectGetApi = <T = any>() => {
    return alovaInstance.Get<T>('/pm/contract-type/receipt/tree');
};

// 查询全部工程类型 api
export const engineerTypeGetApi = <T = any>() => {
    return alovaInstance.Get<T>('/pm/engineer-type/all');
};

// 根据父级ID获取省市区，根节点为-1
export const areaGetApi = <T = Record<string, any>[]>(parenId: string, name?: string) => {
    return alovaInstance.Get<T>(`/admin/sys-area/child/${parenId}`, { params: { name } });
};

// 所属合同的下拉选择 api
export const conSelecRateGetApi = <T = Record<string, any>[]>(name?: string, projectId?: string) => {
    return alovaInstance.Get<T>('/pm/receipt/contract-info/receipt/contract/technical-rate/select/data', {
        params: { name, projectId }
    });
};

// 根据合同id查询发票税率 api
export const taxPointInfoGetApi = <T = any>(id: string) => {
    return alovaInstance.Get<T>(`/pm/contract-partner-rate/get-tax-point/${id}`);
};
